import { UapiHarvestStatsByDateBucket, UapiHarvestStatsByRangeBucket, UapiHarvestStatsBySeedProductBucket } from '../../../../../../graphql/sdk';
import { RootLevelByElevationDimension, RootLevelByPlantingDateDimension, RootLevelByPopulationDimension, RootLevelBySeedProductDimension } from '../../../../../../types/FieldRegionReport';
import { adaptByRangeDimension, adaptByDateDimension, mapBySeedProductDimension, mapByRangeDimension, adaptBySeedProductDimension, mapByDateDimension } from './levelTwoAdapters';

export const mapRootLevelBySeedProductDimension = (
  items: Array<UapiHarvestStatsBySeedProductBucket>
): RootLevelBySeedProductDimension[] => {
  if(!items || !Array.isArray(items)) {
    return [];
  }

  return items.map(item => {
    const baseSeedProductAttributes = mapBySeedProductDimension(item);
    return {
      ...baseSeedProductAttributes,
      dimensions: {
        byElevation: adaptByRangeDimension(item.dimensions?.byElevation ?? []),
        byPopulation: adaptByRangeDimension(item.dimensions?.byPopulation ?? []),
        byPlantingDate: adaptByDateDimension(item.dimensions?.byPlantingDate ?? []),
      }
    };
  });
};

export const mapRootLevelByElevationDimension = (
  items: Array<UapiHarvestStatsByRangeBucket>
): RootLevelByElevationDimension[] => {
  if(!items || !Array.isArray(items)) {
    return [];
  }

  return items.map(item => {
    const baseRangeAttributes = mapByRangeDimension(item);
    return {
      ...baseRangeAttributes,
      dimensions: {
        bySeedProduct: adaptBySeedProductDimension(item.dimensions?.bySeedProduct ?? []),
        byPopulation: adaptByRangeDimension(item.dimensions?.byPopulation ?? []),
        byPlantingDate: adaptByDateDimension(item.dimensions?.byPlantingDate ?? []),
      }
    };
  });
};

export const mapRootLevelByPopulationDimension = (
  items: Array<UapiHarvestStatsByRangeBucket>
): RootLevelByPopulationDimension[] => {
  if(!items || !Array.isArray(items)) {
    return [];
  }

  return items.map(item => {
    const baseRangeAttributes = mapByRangeDimension(item);
    return {
      ...baseRangeAttributes,
      dimensions: {
        bySeedProduct: adaptBySeedProductDimension(item.dimensions?.bySeedProduct ?? []),
        byElevation: adaptByRangeDimension(item.dimensions?.byElevation ?? []),
        byPlantingDate: adaptByDateDimension(item.dimensions?.byPlantingDate ?? []),
      }
    };
  });
};

export const mapRootLevelByPlantingDateDimension = (
  items: Array<UapiHarvestStatsByDateBucket>
): RootLevelByPlantingDateDimension[] => {
  if(!items || !Array.isArray(items)) {
    return [];
  }

  return items.map(item => {
    const baseRangeAttributes = mapByDateDimension(item);
    return {
      ...baseRangeAttributes,
      dimensions: {
        bySeedProduct: adaptBySeedProductDimension(item.dimensions?.bySeedProduct ?? []),
        byElevation: adaptByRangeDimension(item.dimensions?.byElevation ?? []),
        byPopulation: adaptByRangeDimension(item.dimensions?.byPopulation ?? []),
      }
    };
  });
};

